import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function searchHistoryRoutes($stateProvider: StateProvider) {
    let searchHistoryModule: { default: any; };
    $stateProvider
        .state({
            name: 'search-history',
            url: '/search-history',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => searchHistoryModule.default,
            },
            lazyLoad: async () => {
                searchHistoryModule = await import(/* webpackChunkName: "searchHistoryPage" */ './KpSearchHistoryPage.svelte');
                return null;
            }
        });
}